module.exports = __webpack_public_path__ + "avatar3.svg?560a331413377b0e2a3a393668d81070";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/Avatar-Blue-Pool/avatar3.svg
// module id = 139
// module chunks = 2